import * as XLSX from 'xlsx'

const aoaToSpreadSheet = (aoa:any[][], fileName:string, extension="xlsx",)=>{

    const newWorkSheet = XLSX.utils.aoa_to_sheet(aoa)
    const newWorkBook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(newWorkBook, newWorkSheet, "Page 1")

    XLSX.writeFile(newWorkBook, `${fileName}.${extension}`)

}

const readSpreadSheet = async(file:File)=>{

    try {
        const data = await file.arrayBuffer()
        const newWorkBook = XLSX.read(data)
        
        const json:{[key: string]:any}[] = XLSX.utils.sheet_to_json(newWorkBook.Sheets["Page 1"])
        return json
    } catch (error) {
        throw error
    }

}

const Spreadsheet =  {
    aoaToSpreadSheet,
    readSpreadSheet
}

export default Spreadsheet